import type { ActiveTimer, Session, Task } from '@timato/shared';
import { db } from '@/db/db';

export type Goal = Pick<ActiveTimer, 'taskId' | 'projectId' | 'goalText'>;

export const goalFromTask = (t: Task): Goal => ({ taskId: t.id, projectId: t.projectId, goalText: t.name });
export const goalFromProject = (projectId: string): Goal => ({ taskId: null, projectId, goalText: '' });

/**
 * What a logged session was about, as it stands now (TW-27): its task if that still exists, under the task's current
 * name and project; otherwise its project, if still there, and the goal text it was logged with.
 */
export async function goalFromSession(s: Session): Promise<{ goal: Goal; task: Task | null }> {
  const task = s.taskId ? await db.tasks.get(s.taskId) : undefined;
  if (task && !task.deletedAt) return { goal: goalFromTask(task), task };
  const project = s.projectId ? await db.projects.get(s.projectId) : undefined;
  return { goal: { taskId: null, projectId: project && !project.deletedAt ? project.id : null, goalText: s.goalText }, task: null };
}

/** The same goal: the same task, or with no task the same project and words. */
export const sameGoal = (a: Goal, b: Goal) => (a.taskId || b.taskId ? a.taskId === b.taskId : a.projectId === b.projectId && a.goalText.trim() === b.goalText.trim());
